import { useEffect, useState } from 'react'

import { Button, Form, Select, Typography } from 'antd'

import CustomInput from '../../../components/CustomInput/customInput'
import { getMessage } from '../../../util/IntlMessages'
import { api, request } from '../../../util/handlerRequestUtil'

const CreateGroup = ({
  groupId,
  setModalGroupVisible,
  customerId,
  currentGroupName,
  currentGroup,
  updateGroupsList,
  customerLocations = [],
  districts = [],
  onGroupCreated
}) => {
  const [groupName, setGroupName] = useState('')
  const [selectedDistrictIds, setSelectedDistrictIds] = useState([])
  const [groupNameError, setGroupNameError] = useState({ error: false, message: '' })
  const [districtOptions, setDistrictOptions] = useState(districts)
  const [locations, setLocations] = useState(customerLocations)

  useEffect(() => {
    if (currentGroupName) {
      setGroupName(currentGroupName)
    }

    if (groupId && currentGroup?.locations) {
      const districtIds = [
        ...new Set(
          currentGroup.locations
            .map((groupLocation) => groupLocation?.location?.districtId)
            .filter(Boolean)
            .map(Number)
        )
      ]
      setSelectedDistrictIds(districtIds)
    } else {
      setSelectedDistrictIds([])
    }
  }, [groupId, currentGroupName, currentGroup])

  useEffect(() => {
    setDistrictOptions(districts)
  }, [districts])

  useEffect(() => {
    setLocations(customerLocations)
  }, [customerLocations])

  const handleSubmit = async () => {
    const validationError = await validateGroupName(groupName)

    if (validationError) {
      setGroupNameError(validationError)
      return
    }

    const data = {
      description: groupName.toUpperCase(),
      customerId: +customerId,
      locationIds: getLocationIdsByDistricts(selectedDistrictIds)
    }

    if (groupId) {
      await updateGroup(groupId, data)
    } else {
      const group = await createGroup(data)
      updateGroupsList({ ...group, documents: [] })
      setSelectedDistrictIds([])
      if (onGroupCreated && group) {
        onGroupCreated(group)
      }
    }

    setModalGroupVisible()
    setGroupName('')
    return
  }

  const createGroup = async (data) => {
    try {
      const response = await request(api.createCustomerGroup(data))
      return response
    } catch (error) {
      setGroupNameError({ error: true, message: error.message })
    }
  }

  const updateGroup = async (id, data) => {
    try {
      await request(api.updateCustomerGroup(id, data))
    } catch (error) {
      setGroupNameError({ error: true, message: error.message })
    }
  }

  async function groupExistCheck(groupNameCheck) {
    let groupExist = false
    const groups = await request(api.listCustomerGroupByCustomerId(customerId), false, true)

    await groups.forEach((group) => {
      if (
        +group.id !== +groupId &&
        group.description.toUpperCase().replace(/\s/g, '') === groupNameCheck.toUpperCase().replace(/\s/g, '')
      ) {
        groupExist = true
      }
    })
    return groupExist
  }

  const validateGroupName = async (groupName) => {
    if (!groupName) {
      return { error: true, message: 'O nome do grupo não pode estar vazio' }
    }

    const groupExists = await groupExistCheck(groupName)

    if (groupExists) {
      return { error: true, message: 'Já existe um grupo com esse nome' }
    }
    return null
  }

  const getLocationIdsByDistricts = (districtIds) => {
    if (!Array.isArray(locations)) {
      return []
    }

    const locationIds = locations
      .filter((location) => districtIds.includes(+location.districtId))
      .map((location) => +location.id)

    return [...new Set(locationIds)]
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <Form layout="vertical" style={{ width: '100%', margin: 0 }}>
          <CustomInput
            field="groupNameCreate"
            name="groupName"
            placeholder={getMessage('groupNameCreate')}
            value={{ groupName }}
            setFieldValue={(_, value) => setGroupName(value)}
            rowSpan={24}
            colStyle={{
              width: '100%',
              maxWidth: '100%',
              paddingLeft: 0,
              paddingRight: 0,
              margin: 0
            }}
            required
          />
        </Form>

        <div>
          <Typography style={{ marginTop: 10 }}>Distritos</Typography>
          <Select
            mode="multiple"
            style={{ width: '100%', marginBottom: 10 }}
            value={selectedDistrictIds}
            onChange={(value) => setSelectedDistrictIds(value)}
            placeholder="Selecione os distritos"
            optionFilterProp="label"
          >
            {districtOptions.map(({ value, label }) => (
              <Select.Option key={value} value={value} label={label}>
                {label}
              </Select.Option>
            ))}
          </Select>
        </div>

        {groupNameError.error && <span style={{ color: '#f5222d' }}>{getMessage(groupNameError.message)}</span>}
      </div>

      <div style={{ display: 'flex', marginTop: 5, width: '100%', justifyContent: 'space-between' }}>
        <Button
          onClick={() => {
            setGroupName('')
            setModalGroupVisible(false)
            setGroupNameError('')
          }}
          type="ghost"
          style={{ borderColor: '#b58bfa', color: '#b58bfa', width: '100%' }}
        >
          {getMessage('cancel')}
        </Button>
        <Button type="dashed" onClick={handleSubmit} style={{ fontSize: '12px', width: '100%' }}>
          {groupId ? getMessage('update') : getMessage('storeContacts')}
        </Button>
      </div>
    </div>
  )
}

export default CreateGroup
